<template>
  <ul v-bind:class="{ 'mobi-menu-primary-ul': parameters === true }">
    <li v-for="(link, index) in links" v-bind:key="index" @click="toggleMenu()">
      <router-link v-bind:to="link.link"
        ><span>{{ link.name }}</span></router-link
      >
    </li>
    <li v-if="isMainPage">
      <div class="main-sort-name main-sort-field">
        <input
          v-model="search"
          placeholder="Название"
          title="Название"
          type="text"
        />
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: "Menu",
  props: {
    parameters: Boolean,
    user: Object
  },
  computed: {
    search: {
      get() {
        return this.$store.getters["common/search"];
      },
      set(newValue) {
        this.$store.commit("common/SET_SEARCH", newValue);
      }
    },
    isMainPage() {
      return this.$route.name === "stations";
    }
  },
  methods: {
    toggleMenu() {
      if (this.parameters) {
        this.$store.dispatch("common/toggleMenu");
      }
    }
  },
  data() {
    if (this.user.isSuper) {
      return {
        links: [
          {
            link: "/users",
            name: "Пользователи"
          },
          {
            link: "/restrictions",
            name: "Ограничения"
          },
          {
            link: "/restrictions-history",
            name: "История ограничений"
          },
          {
            link: "/map",
            name: "Карта"
          },
          {
            link: "/device-command-history",
            name: "История команд"
          }
        ]
      };
    } else if (this.user.allowToRestrict) {
      return {
        links: [
          {
            link: "/restrictions",
            name: "Ограничения"
          },
          {
            link: "/map",
            name: "Карта"
          }
        ]
      };
    } else {
      return {
        links: [
          {
            link: "/map",
            name: "Карта"
          }
        ]
      };
    }
  }
};
</script>
